import React from "react";
import project from "./data/projects.json";

const Projects = () => {
  return (
    <>
      <div className="container projects my-2" id="projects">
        <h1 className="my-3 text-center">PROJECTS</h1>
        <div className="flex d-flex  justify-content-center flex-wrap align-content-center mx-auto">
          {project.map((data) => (
            <>
              <div key={data.id} className="my-4 mx-3" >
                <div className="cardpro bg-dark text-light mx-auto"  data-aos="flip-right"  data-aos-duration="1000">
                  <div className="img d-flex justify-content-center align-content-center p-3">
                    <img src={data.imageSrc} className="card-img-top" alt="Image Not Found" />
                  </div>
                  <div className="card-bodypro text-center">
                    <h5 className="card-titlepro text-white" >{data.title}</h5>
                    <p className="card-textpro text-white">{data.description}</p>
                    <a href={data.demo} className="btn btn-outline-warning mx-3" style={{background:"#009999"}}>
                      Demo
                    </a>
                    <a href={data.source} className="btn btn-outline-warning" style={{background:"#00906c"}}>
                      Code
                    </a>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default Projects;
